<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div class="row mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">

              <div class="row mt-2">

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.id')" v-model="requestDTO.id">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.requisites')" v-model="requestDTO.query">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currencies"
                                   class="multiselect-sm"
                                   v-model="requestDTO.currencies"
                                   :options="currencyList"
                                   :custom-label="(opt) => `${opt}`"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.currencies')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="methods"
                                   class="multiselect-sm"
                                   v-model="requestDTO.methods"
                                   :options="methodList()"
                                   :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_methods')"
                      >
                        <template #option="props">
                          <div class="d-flex flex-row align-items-center gap-2">
                            <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                            <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="options"
                                   class="multiselect-sm"
                                   v-model="requestDTO.options"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_options')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statused"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="[1, 0]"
                                   :custom-label="(opt) => opt === 1 ? helper.trans('requisites.active') : helper.trans('requisites.inactive')"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isTrader || isTraderOperator" class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="group"
                                   class="multiselect-sm"
                                   v-model="requestDTO.groupId"
                                   :options="store.getters['reqGroups/ids']"
                                   :custom-label="(opt) => store.getters['reqGroups/get'](opt)?.name"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.req_group')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isOperator || isAdmin || isTeamLead" class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isOperator || isAdmin" class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0">
                      <input class="form-check-input" v-model="requestDTO.isDeleted" true-value="true" type="checkbox" value="" id="isDeleted">
                      <label class="form-check-label" for="isDeleted">
                        {{ helper.trans('labels.deleted')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm"
                             :placeholder="helper.trans('labels.from_sum')" v-model="requestDTO.minAmount">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm"
                             :placeholder="helper.trans('labels.to_sum')" v-model="requestDTO.maxAmount">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="row">
                <div class="col-sm-12 mb-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">{{ helper.trans('labels.requisites') }}</h5>
                    <div>
                      <button v-if="isAdmin || isOperator" type="button" @click="counterpartiesImportModal?.show()" class="btn btn-outline-secondary btn-sm text-capitalize-first me-2">
                        <i class="fa fa-link me-1"></i>{{ helper.trans(storeCounterpartyAllowlistEnabled ? 'counterparty_import.action_allowlist' : 'counterparty_import.action') }}
                      </button>
                      <button v-if="isAdmin" type="button" @click="showImportModal()" class="btn btn-outline-secondary btn-sm text-capitalize-first me-2">
                        <i class="fa fa-file-import me-1"></i>{{ helper.trans('labels.import') }}
                      </button>
                      <button v-if="isAdmin || isOperator" type="button" @click="$refs.traderRequisitesSettingsModal.openModal()" class="btn btn-outline-primary btn-sm text-capitalize-first">
                        <i class="fa fa-cog me-1"></i>{{ helper.trans('button.plan_settings') }}
                      </button>
                    </div>

                  </div>
                </div>

                <div class="form-group col-sm-12">
                  <button v-if="isTrader || isTraderOperator" type="button" v-on:click="showDevicesModal()" class="btn btn-outline-dark btn-sm rounded-pill text-capitalize"><i class="fa fa-mobile-screen-button"></i> {{ helper.trans('button.devices') }}</button>
                  <b-modal v-if="isTrader || isTraderOperator" dialog-class="modal-lg"
                           :title="helper.trans('labels.devices')"
                           :modelValue="devicesModal"
                           body-class="pt-0"
                           @update:modelValue="devicesModal = $event"
                  >
                    <template #default>
                      <DeviceList ref="deviceList"></DeviceList>
                    </template>
                    <template #footer>
                      <button type="button" v-on:click="devicesModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.close') }}</button>

                    </template>
                  </b-modal>

                  <button v-if="isTrader || isTraderOperator" type="button" v-on:click="showGroupsModal()" class="btn btn-outline-dark btn-sm ms-2 rounded-pill text-capitalize">{{ helper.trans('button.groups') }}</button>
                  <b-modal v-if="isTrader || isTraderOperator" dialog-class="modal-lg"
                           :title="helper.trans('button.groups')"
                           :modelValue="groupsModal"
                           body-class="pt-0"
                           @update:modelValue="groupsModal = $event"
                  >
                    <template #default>
                      <GroupsList ref="groupsList"></GroupsList>
                    </template>
                    <template #footer>
                      <button type="button" v-on:click="groupsModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.close') }}</button>

                    </template>
                  </b-modal>

                  <button v-if="isTrader || isTraderOperator" type="button" v-on:click="showEditModal()" class="btn btn-outline-dark btn-sm rounded-pill float-end text-capitalize"><i class="fa fa-plus"></i> {{ helper.trans('button.create') }}</button>
                  <b-modal v-if="isTrader || isTraderOperator || isAdmin || isOperator" dialog-class="modal-lg"
                           :title="createModalTitle"
                           :modelValue="createModal"
                           body-class="pt-0"
                           @update:modelValue="createModal = $event"
                  >
                    <template #default>
                      <RequisitesForm ref="createForm" @show-counterparties="showCounterpartiesModal"></RequisitesForm>
                    </template>
                    <template #footer>
                      <button v-if="isTrader || isTraderOperator" type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                      <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                        <button v-if="isTrader || isTraderOperator" type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                        <button v-if="createForm?.isImport && isAdmin" type="button" @click="makeImport()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('labels.import') }}</button>
                        <button v-if="(isTrader || isTraderOperator || isAdmin || isOperator) && store.getters.getAppData?.requisitesTotalLimitEnabled && createForm?.form?.id && createForm?.form?.manualResetEnabled" type="button" @click="resetTotalLimit()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.reset_total_limit') }}</button>
                      </LoaderWrapper>
                    </template>
                  </b-modal>

                  <b-modal v-if="hasRole([UserRole.ADMIN, UserRole.OPERATOR, UserRole.TRADER, UserRole.TRADER_OPERATOR])" dialog-class="modal-lg"
                           :title="helper.trans('labels.history')"
                           :modelValue="historyModal"
                           body-class="pt-0"
                           @update:modelValue="historyModal = $event"
                  >
                    <template #default>
                      <div class="mt-3">
                        <table class="table table-striped border-light">
                          <thead>
                          <tr>
                            <th class="text-capitalize">{{ helper.trans('labels.date') }}</th>
                            <th class="text-capitalize">{{ helper.trans('labels.status') }}</th>
                            <th class="text-capitalize">{{ helper.trans('labels.field') }}</th>
                            <th class="text-capitalize">{{ helper.trans('labels.initiator') }} / {{ helper.trans('labels.action_type') }}</th>
                            <th v-if="!(isTrader || isTraderOperator)" class="text-capitalize">{{ helper.trans('labels.user') }}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="group in groupedHistory" :key="group.changeGroupId">
                            <td class="text-nowrap">{{ dateHelper.format(group.date) }}</td>
                            <td>
                              <div class="d-flex flex-column">
                                <span class="fw-bold">{{ getActionDescription(group.changes) }}</span>
                                <small v-if="group.changes.length > 1" class="text-muted">
                                  Изменено полей: {{ group.changes.length }}
                                </small>
                              </div>
                            </td>
                            <td>
                              <div class="d-flex flex-column">
                                <div v-for="change in group.changes" :key="change.id" class="mb-1">
                                  <small>
                                    <span class="text-muted">{{ getFieldName(change.fieldName) }}:</span>
                                    <span class="text-danger">{{ formatValue(change.oldValue, change.fieldName) }}</span>
                                    <i class="fa fa-arrow-right mx-1 text-muted"></i>
                                    <span class="text-success">{{ formatValue(change.newValue, change.fieldName) }}</span>
                                  </small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="d-flex flex-column">
                                <small class="text-capitalize-first">{{ helper.trans(`user_roles.${group.initiatorRole}`) }}</small>
                                <small class="text-muted">{{ helper.trans(`initiator_type.${group.initiatorType}`) }}</small>
                              </div>
                            </td>
                            <td v-if="!(isTrader || isTraderOperator)">
                              <div class="d-flex flex-column">
                                <UserNameLabel show-badge v-if="group.initiator" :user="group.initiator"></UserNameLabel>
                                <small v-else class="text-muted">-</small>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <div v-if="requisitesHistoryResponse.items.length === 0" class="text-center text-muted py-3">
                          {{ helper.trans('labels.no_history') }}
                        </div>

                        <b-pagination
                          v-if="requisitesHistoryResponse.totalCount > requisitesHistoryResponse.items.length"
                          v-model="historyPage"
                          :total-rows="requisitesHistoryResponse.totalCount"
                          :per-page="requisitesHistoryResponse.limit"
                          :limit="20"
                          @update:modelValue="() => currentRequisites && loadRequisitesHistory(currentRequisites)"
                          prev-text="Back"
                          next-text="Next"
                          align="start"
                          first-number
                          hide-goto-end-buttons
                          hide-ellipsis
                        ></b-pagination>
                      </div>
                    </template>
                    <template #footer>
                      <button type="button" v-on:click="historyModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.ok') }}</button>
                    </template>
                  </b-modal>

                  <b-modal v-if="isAdmin || isOperator" dialog-class="modal-lg"
                           :title="helper.trans('labels.sum_limits')"
                           :modelValue="payInDealSumsModal"
                           body-class="pt-0"
                           @update:modelValue="payInDealSumsModal = $event"
                  >
                    <template #default>
                      <RequisitesPayInDealSumsForm :ref="(el) => payInDealSumsForm = el"></RequisitesPayInDealSumsForm>
                    </template>
                    <template #footer>
                      <button type="button" v-on:click="payInDealSumsModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                      <LoaderWrapper :ref="(el) => loaderPayInDealSums = el" :zoom="0.5">
                        <button type="button" @click="savePayInDealSums()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                      </LoaderWrapper>
                    </template>
                  </b-modal>

                </div>
              </div>

              <div v-if="requisites.items.some(hasFrozenSums)" class="d-flex flex-wrap gap-3 small text-muted mb-2">
                <span v-for="status in ['free', 'in_progress', 'near_limit', 'limit', 'inactive']" :key="status" class="d-inline-flex align-items-center gap-1">
                  <span class="requisite-status-dot" :class="'requisite-status-dot--' + status"></span>{{ helper.trans('requisites.status_' + status) }}
                </span>
              </div>

              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th v-if="(isTrader || isTraderOperator) && reorderEnabled" style="width: 0"></th>
                    <th v-if="isAdmin || isOperator" class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th v-if="isAdmin || isOperator || isTeamLead" class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.device') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.requisites') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.req_group') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.sum_limits') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.volume_limits') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.count_limits') }}</th>
                    <th class="text-capitalize-first text-wrap" style="width: 0">{{ helper.trans('labels.concurrent_trader_count_short') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <Sortable
                    :list="requisites.items"
                    item-key="id"
                    tag="tbody"
                    @end="onRequisitesReorder($event)"
                    :options="{draggable: '.draggable', handle: '.drag-handle', disabled: !reorderEnabled || !(isTrader || isTraderOperator)}"
                  >
                  <template #item="{element: item}">
                    <tr class="draggable" :key="item.id">
                    <td v-if="(isTrader || isTraderOperator) && reorderEnabled" style="width: 0">
                      <div class="drag-handle p-2" style="cursor: grab">
                        <i class="fa-solid fa-grip-vertical"></i>
                      </div>
                    </td>
                    <td v-if="isAdmin || isOperator" >
                      {{ item.id }}
                    </td>
                    <td v-if="isAdmin || isOperator || isTeamLead">
                      <UserNameLabel v-if="item.trader" :user="item.trader"/>
                    </td>
                    <td>
                      <DeviceLabel :device="item.device" @device:updated="onDeviceUpdated" show-id></DeviceLabel>
                    </td>
                    <td>
                      <div class="d-flex flex-row align-items-center gap-2 mt-1 mb-1">
                        <PayMethodIcon :method="item.method"></PayMethodIcon>
                        <div class="d-flex flex-column">
                          <small class=""> {{ helper.trans('payment_options.' + item.paymentOption) }} <span v-if="item.crossBorderCurrency">{{item.crossBorderCurrency}}</span> <span v-if="item.paymentSystem">{{ helper.trans('payment_systems.' + item.paymentSystem) }}</span> <span v-if="item.p2cConfig?.service_name">{{ helper.trans(`multitransfer.service.${item.p2cConfig?.service_name}`) }}</span></small>
                          <template v-if="crossBorderSwift(item.raw)">
                            <small class="text-secondary">{{ item.holderName }}</small>
                            <span>
                              {{ item.requisites }}
                              <copy-button :value="item.requisites" class="ms-1"></copy-button>
                            </span>
                            <small>{{ helper.trans('labels.raw_field.swift') }} {{ crossBorderSwift(item.raw) }}</small>
                          </template>
                          <template v-else>
                          <span>
                            <a v-if="item.paymentOption === PaymentOption.SBP_QR && item.requisites?.startsWith('http')" :href="item.requisites" target="_blank">{{ helper.domain(item.requisites) }}</a>
                            <span v-else-if="item.paymentOption === PaymentOption.MANUAL_SBP_QR" class="text-muted">—</span>
                            <a v-else-if="item.paymentOption === PaymentOption.CLICK_UZ_QR && item.requisites.startsWith('http')" :href="item.requisites" target="_blank">{{ helper.trans('labels.my_click_uz') }}</a>
                            <a v-else-if="item.paymentOption === PaymentOption.TIPS && item.requisites.startsWith('http')" :href="item.requisites" target="_blank">{{ helper.domain(item.requisites) }}</a>
                            <span
                              v-else-if="item.paymentOption === PaymentOption.VIET_QR"
                              v-b-tooltip.hover
                              class="font-monospace text-break"
                              :title="vietQrEmvFromRaw(item.raw) || undefined"
                            >{{ truncateVietQrEmvDisplay(vietQrEmvFromRaw(item.raw)) || '—' }}</span>
                            <span
                              v-else-if="item.paymentOption === PaymentOption.IND_QR"
                              v-b-tooltip.hover
                              class="font-monospace text-break"
                              :title="qrisEmvFromRaw(item.raw) || undefined"
                            >{{ truncateVietQrEmvDisplay(qrisEmvFromRaw(item.raw)) || '—' }}</span>
                            <span
                              v-else-if="item.paymentOption === PaymentOption.BR_QR"
                              v-b-tooltip.hover
                              class="font-monospace text-break"
                              :title="pixEmvFromRaw(item.raw) || undefined"
                            >{{ truncateVietQrEmvDisplay(pixEmvFromRaw(item.raw)) || '—' }}</span>
                            <span v-else>{{ item.requisites }}</span>

                            <copy-button v-if="item.paymentOption !== PaymentOption.MANUAL_SBP_QR" :value="item.paymentOption === PaymentOption.VIET_QR ? vietQrEmvFromRaw(item.raw) : item.paymentOption === PaymentOption.IND_QR ? qrisEmvFromRaw(item.raw) : item.paymentOption === PaymentOption.BR_QR ? pixEmvFromRaw(item.raw) : item.requisites" class="ms-1"></copy-button>
                            <RequisiteFillStatusDot v-if="hasFrozenSums(item)" :item="item" class="ms-2"></RequisiteFillStatusDot>
                          </span>
                          <small class="text-secondary"> {{ item.holderName }}</small>
                          </template>
                          <small class="text-danger" v-if="item?.deletedAt !== null">{{helper.trans('labels.deleted')}}</small>
                        </div>

                      </div>
                    </td>
                    <td>
                      {{ item.group?.name ?? 'n/a' }}
                      <i v-if="item.group?.trafficGroupIds?.length > 0" class="fa fa-warning text-warning" v-b-tooltip.hover :title="helper.trans('labels.req_group_traffic_groups_warning', {groups: item.group?.trafficGroupIds.map((id) => store.getters['trafficGroups/get'](id)?.name)})"></i>
                    </td>
                    <td>
                      {{ item.currency }}
                    </td>
                    <td>
                      <div class="d-flex flex-row justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                          <span v-if="!item.minPayInDealSum && !item.maxPayInDealSum">n/a</span>
                          <span v-if="item.minPayInDealSum">{{ helper.trans('labels.from_limit', {sum: numberFormatter.formatNumber(item.minPayInDealSum), currency: item.minPayInDealSum!.currency })}}</span>
                          <span v-if="item.maxPayInDealSum">{{ helper.trans('labels.to_limit', {sum: numberFormatter.formatNumber(item.maxPayInDealSum), currency: item.maxPayInDealSum!.currency })}}</span>
                        </div>
                        <button v-if="isAdmin || isOperator" type="button" @click="showEditPayInDealSumsModal(item)" class="btn btn-sm btn-link text-nowrap text-capitalize"><i class="fa fa-pencil"></i></button>
                      </div>

                    </td>

                    <td>
                      <div class="d-flex flex-column"  style="width: 200px">
                        <span class="mb-2" v-b-tooltip.hover :title="sumTitle('labels.day', item.dayTradesSum, item.dayTradesFrozenSum)">
                          <RequisiteSumProgress v-if="hasFrozenSums(item)" :total="item.dayTradesSum" :frozen="item.dayTradesFrozenSum" :limit="item.dayTradesSumLimit" :active="item.isActive"></RequisiteSumProgress>
                          <b-progress v-else :max="parseInt(item.dayTradesSumLimit.amount)" class="progress-bar-striped position-relative">
                            <b-progress-bar :value="parseInt(item.dayTradesSum.amount)" class="progress-bar-striped" :class="{'bg-warning': isDayLimitReached(item), 'bg-secondary-light': !isDayLimitReached(item)}"></b-progress-bar>
                            <small class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(item.dayTradesSum) }}/{{ numberFormatter.formatNumber(item.dayTradesSumLimit) }}</small>
                          </b-progress>
                        </span>
                        <span v-b-tooltip.hover :title="sumTitle('labels.month', item.monthTradesSum, item.monthTradesFrozenSum)">
                          <RequisiteSumProgress v-if="hasFrozenSums(item)" :total="item.monthTradesSum" :frozen="item.monthTradesFrozenSum" :limit="item.monthTradesSumLimit" :active="item.isActive"></RequisiteSumProgress>
                          <b-progress v-else :max="parseInt(item.monthTradesSumLimit.amount)" class="progress-bar-striped position-relative">
                            <b-progress-bar :value="parseInt(item.monthTradesSum.amount)" class="progress-bar-striped" :class="{'bg-warning': isMonthLimitReached(item), 'bg-secondary-light': !isMonthLimitReached(item)}"></b-progress-bar>
                            <small class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(item.monthTradesSum) }}/{{ numberFormatter.formatNumber(item.monthTradesSumLimit) }}</small>
                          </b-progress>
                        </span>

                      </div>
                    </td>

                    <td>
                      <div class="d-flex flex-column"  style="width: 100px">
                        <span class="mb-2" v-b-tooltip.hover :title="helper.trans('labels.day')">
                          <b-progress :max="item.dayTradesCountLimit" class="progress-bar-striped position-relative">
                            <b-progress-bar :value="item.dayTradesCountLimit === 0 ? 0 : item.dayTradesCount" class="progress-bar-striped" :class="{'bg-warning': item.dayTradesCountLimit > 0 && item.dayTradesCount/item.dayTradesCountLimit >= 0.9, 'bg-secondary-light': item.dayTradesCountLimit === 0 || item.dayTradesCount/item.dayTradesCountLimit < 0.9}"></b-progress-bar>
                            <small v-if="item.dayTradesCountLimit === 0" class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(item.dayTradesCount) }}</small>
                            <small v-else class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(item.dayTradesCount) }}/{{ numberFormatter.formatNumber(item.dayTradesCountLimit) }}</small>
                          </b-progress>
                        </span>

                        <span v-b-tooltip.hover :title="helper.trans('labels.month')">
                          <b-progress :max="item.monthTradesCountLimit" class="progress-bar-striped position-relative">
                            <b-progress-bar :value="item.monthTradesCountLimit === 0 ? 0 : item.monthTradesCount" class="progress-bar-striped" :class="{'bg-warning': item.monthTradesCountLimit > 0 && item.monthTradesCount/item.monthTradesCountLimit >= 0.9, 'bg-secondary-light': item.monthTradesCountLimit === 0 || item.monthTradesCount/item.monthTradesCountLimit < 0.9}"></b-progress-bar>
                            <small v-if="item.monthTradesCountLimit === 0" class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(item.monthTradesCount) }}</small>
                            <small v-else class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(item.monthTradesCount) }}/{{ numberFormatter.formatNumber(item.monthTradesCountLimit) }}</small>
                          </b-progress>
                        </span>

                      </div>
                    </td>

                    <td>
                      <span v-if="item.concurrentTradesCount">{{ numberFormatter.formatNumber(item.concurrentTradesCount) }}</span>
                      <span v-else>n/a</span>
                    </td>

                    <td>
                      <div class="form-check form-switch d-flex align-items-center form-check-success" >
                        <input v-b-tooltip.hover :title="item.isActive ? helper.trans('requisites.active') : helper.trans('requisites.inactive')" v-model="item.isActive" @change="toggleRequisitesActivity($event, item)" id="isActive" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch">
                      </div>
                    </td>
                    <td class="text-end">
                      <button v-if="item.device && (isTrader || isTraderOperator || isAdmin || isOperator)" type="button" @click="$refs.deviceMessageLogsModal.setDevice(item.device)" class="btn btn-sm btn-outline-secondary text-nowrap me-2"><i class="fa-regular fa-comments"></i></button>
                      <button v-if="item.isWhiteTriangle && (isTrader || isTraderOperator || isTeamLead) && store.getters.getAppData?.fraudexEnabled" type="button" @click="showFraudexFeedbackModal(item)" v-b-tooltip.hover :title="helper.trans('fraudex.leave_feedback')" class="btn btn-sm btn-outline-primary text-nowrap me-2"><i class="fa fa-comment-dots"></i></button>
                      <button v-if="isAdmin || isOperator || isTrader || isTraderOperator" type="button" @click="showHistoryModal(item)" class="btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"><i class="fa fa-list"></i></button>
                      <button v-if="isAdmin || isOperator" type="button" @click="showEditModal(item)" class="btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"><i class="fa fa-eye"></i></button>
                      <button v-if="isTrader || isTraderOperator" type="button" @click="showEditModal(item)" class="btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                      <button v-if="isTrader || isTraderOperator" type="button" @click="deleteRequisites = item" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-trash"></i> {{helper.trans('button.delete')}}</button>
                    </td>
                    </tr>
                  </template>
                  </Sortable>
                </table>

                <b-pagination
                  v-if="requisites.totalCount > requisites.items.length"
                  v-model="page"
                  :total-rows="requisites.totalCount"
                  :per-page="requisites.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  :prev-text="helper.trans('button.back')"
                  :next-text="helper.trans('button.next')"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <div>
      <b-modal :title="helper.trans('labels.delete_confirm')" :modelValue="deleteRequisites !== null" body-class="d-none" footer-class="border-top-0 d-flex justify-content-between" @update:modelValue="$event === false && (deleteRequisites = null)">
        <template #footer>
          <button type="button" @click="deleteRequisites = null" class="btn btn-outline-dark btn-sm text-capitalize">{{ helper.trans('button.cancel') }}</button>
          <LoaderWrapper ref="loaderDeleteRequisites" :zoom="0.5">
            <button type="button" @click="confirmRequisitesDelete()" class="btn btn-outline-danger btn-sm text-capitalize">{{ helper.trans('button.delete') }}</button>
          </LoaderWrapper>
        </template>
      </b-modal>
      <DeviceMessageLogsModal ref="deviceMessageLogsModal"></DeviceMessageLogsModal>
    </div>
    <BlacklistMethodAgreementModal @state:updated="onBlackListModalUpdated($event)" ref="requisitesConfirmModal"></BlacklistMethodAgreementModal>
    <TraderRequisitesSettingsModal ref="traderRequisitesSettingsModal"></TraderRequisitesSettingsModal>
    <CounterpartiesModal ref="counterpartiesModal"></CounterpartiesModal>
    <CounterpartiesImportModal v-if="isAdmin || isOperator" ref="counterpartiesImportModal" @imported="onCounterpartiesImported"></CounterpartiesImportModal>
    <FraudexCheckModal
      v-if="store.getters.getAppData?.fraudexEnabled"
      v-model:visible="fraudexCheckModal"
      :fraudex-check="fraudexCheckData?.fraudexCheck || null"
      @continue="handleFraudexCheckContinue"
      @cancel="handleFraudexCheckCancel"
    ></FraudexCheckModal>
    <FraudexFeedbackModal
      v-if="store.getters.getAppData?.fraudexEnabled"
      v-model:visible="fraudexFeedbackModal"
      :requisite="fraudexFeedbackRequisite?.requisites || ''"
      @submit="handleFraudexFeedbackSubmit"
    ></FraudexFeedbackModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import CopyButton from "@/components/CopyButton.vue";
import TraderRequisitesSettingsModal from "@/components/TraderRequisitesSettingsModal.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRef, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {hasFrozenSums, sumTitle} from "@/service/requisiteFrozenSums";
import RequisiteSumProgress from "@/components/RequisiteSumProgress.vue";
import RequisiteFillStatusDot from "@/components/RequisiteFillStatusDot.vue";
import APIClient from "@/service/APIClient";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {helper} from "@/service/CommonHelper";
import RequisitesRequestDTO from "@/models/request/RequisitesRequestDTO";
import {BModal, BPagination, BProgress, BProgressBar} from "bootstrap-vue-3";
import {Sortable} from "sortablejs-vue3";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import RequisitesForm from "@/components/Form/RequisitesForm.vue";
import RequisitesFormDTO from "@/models/form/RequisitesFormDTO";
import {useNotification} from "@kyvg/vue3-notification";
import RequisitesUpdateRequestDTO from "@/models/request/RequisitesUpdateRequestDTO";
import DeviceList from "@/components/DeviceList.vue";
import {useStore} from "vuex";
import GroupsList from "@/components/GroupsList.vue";
import PaginationDTO from "@/models/PaginationDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import Multiselect from "vue-multiselect";
import TraderDTO from "@/models/TraderDTO";
import {Dictionary} from "@/types";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TraderRequisiteGroupDTO from "@/models/TraderRequisiteGroupDTO";
import DeviceMessageLogsModal from "@/components/DeviceMessageLogsModal.vue";
import DeviceLabel from "@/components/DeviceLabel.vue";
import RequisitesPayInDealSumsForm from "@/components/Form/RequisitesPayInDealSumsForm.vue";
import RequisitesPayInDealSumsFormDTO from "@/models/form/RequisitesPayInDealSumsFormDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {PaymentOption} from "@/models/enum/PaymentOption";
import {buildPixRawPayload, buildQrisRawPayload, buildVietQrRawPayload, isPixRawComplete, isQrisRawComplete, isVietQrRawComplete, pixBackendErrorLabel, pixEmvFromRaw, qrisBackendErrorLabel, qrisEmvFromRaw, truncateVietQrEmvDisplay, vietQrEmvFromRaw} from "@/service/vietQrRawHelpers";
import {crossBorderAccountRequisites, crossBorderRawPayload, crossBorderSwift} from "@/service/crossBorderSwift";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import BlacklistMethodAgreementModal from "@/components/BlacklistMethodAgreementModal.vue";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import {UserRole} from "@/models/enum/UserRole";
import RequisitesActionHistoryDTO from "@/models/RequisitesActionHistoryDTO";
import UserDTO from "@/models/UserDTO";
import CounterpartiesModal from "@/components/CounterpartiesModal.vue";
import CounterpartiesImportModal from "@/components/CounterpartiesImportModal.vue";
import FraudexCheckModal from "@/components/FraudexCheckModal.vue";
import FraudexFeedbackModal from "@/components/FraudexFeedbackModal.vue";
import BulkRequisitesUploadRequestDTO from "@/models/request/BulkRequisitesUploadRequestDTO";

const api = new APIClient();
const notification = useNotification()

const defaultCreateForm = {
  id: null as number|null,
  isActive: false,
  isWhiteTriangle: false,
  requisites: null,
  holderName: null,
  accountNumber: null,
  method: null,
  maxReuseCount: null,
  reuseDaysCount: 10,
  paymentOption: null,
  currency: null,
  crossBorderCurrency: null,
  dayTradesCountLimit: 0,
  monthTradesCountLimit: 0,
  dayTradesAllCountLimit: 0,
  monthTradesAllCountLimit: 0,
  dayTradesSumLimit: null,
  monthTradesSumLimit: null,
  totalTradesCountLimit: 0,
  totalTradesSumLimit: null,
  manualResetEnabled: false,
  deviceId: null,
  groupId: null,
  minPayInDealSum: null,
  maxPayInDealSum: null,
  multiplesOfValue: null,
  payInDealSumsEditable: true,
  isFarmsSettingsEnabled: false,
  onlyInternalTransfer: false,
  concurrentTradesCount: null,
  tradesTimeoutMinutes: null,
  p2cConfig: {},
  raw: {},
  qrisIsStatic: false,
  pixIsStatic: false,
} as RequisitesFormDTO

export default defineComponent({
  name: 'PayInRequisites',
  components: {
    FormInputWrapper,
    BlacklistMethodAgreementModal,
    TraderRequisitesSettingsModal,
    PayMethodIcon,
    RequisitesPayInDealSumsForm,
    BProgressBar,
    BProgress,
    RequisiteSumProgress,
    RequisiteFillStatusDot,
    DeviceMessageLogsModal,
    LoaderWrapper,
    CopyButton,
    BPagination,
    BModal,
    RequisitesForm,
    DeviceList,
    GroupsList,
    UserNameLabel,
    TraderMultiselect,
    Multiselect,
    DeviceLabel,
    CounterpartiesModal,
    CounterpartiesImportModal,
    FraudexCheckModal,
    FraudexFeedbackModal,
    Sortable
  },
  setup() {
    const store = useStore();
    const reorderEnabled = computed(() => !!store.getters.getAppData?.REQUISITES_MANUAL_REORDER_ENABLED)
    const storeCounterpartyAllowlistEnabled = computed(() => !!store.getters.getAppData?.STORE_COUNTERPARTY_ALLOWLIST_ENABLED)

    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderPayInDealSums = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderDeleteRequisites = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const payInDealSumsForm = ref<InstanceType<typeof RequisitesPayInDealSumsForm> | null>(null)
    const createForm = ref<InstanceType<typeof RequisitesForm> | null>(null)
    const deviceList = ref<InstanceType<typeof DeviceList> | null>(null)
    const groupsList = ref<InstanceType<typeof GroupsList> | null>(null)
    const requisitesConfirmModal = ref<InstanceType<typeof BlacklistMethodAgreementModal> | null>(null)
    const counterpartiesModal = ref<InstanceType<typeof CounterpartiesModal> | null>(null)
    const counterpartiesImportModal = ref<InstanceType<typeof CounterpartiesImportModal> | null>(null)

    const state = reactive({
      tradersFilter: [] as TraderDTO[],
      deleteRequisites: null as TraderRequisitesDTO|null,
      currentRequisites: null as TraderRequisitesDTO|null,
      historyModal: false,
      createModal: false,
      payInDealSumsModal: false,
      devicesModal: false,
      groupsModal: false,
      createModalTitle: '',
      fraudexCheckModal: false,
      fraudexCheckData: null as TraderRequisitesDTO|null,
      fraudexFeedbackModal: false,
      fraudexFeedbackRequisite: null as TraderRequisitesDTO|null,
      page: 1,
      requestDTO: {
        id: null,
        ids: [],
        currencies: [],
        traderIds: [],
        methods: [],
        statuses: [],
        options: [],
        query: '',
        groupId: null,
        isDeleted: 'false',
        minAmount: null,
        maxAmount: null,
        deviceId: null,
        storeId: null,
        counterpartyUserId: null,
      } as RequisitesRequestDTO,
      requisites: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<TraderRequisitesDTO>,
      blacklistMethods: [] as string[],
      requisitesHistoryResponse: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: [] as RequisitesActionHistoryDTO[]
      } as PaginatedResponseDTO<RequisitesActionHistoryDTO>,
      historyPage: 1,
    });

    const load = async () => {
      state.requisites.offset = state.requisites.limit * (state.page - 1)
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      pageLoader.value?.show()
      state.requisites = await api.requisites(state.requisites, reorderEnabled.value ? {sortOrder: 'asc'} : {createdAt: 'desc'}, state.requestDTO)
      let traderIds = [];
      let deviceIds = [];
      for (const item of state.requisites.items) {
        traderIds.push(item.traderId)
        if (item.deviceId) {
          deviceIds.push(item.deviceId)
        }
      }

      let groups = {} as Dictionary<TraderRequisiteGroupDTO>;
      let traders = {} as Dictionary<TraderDTO>;
      let devices = {} as Dictionary<TraderDeviceDTO>;
      for (const group of (await api.traderRequisiteGroups({offset:0, limit: traderIds.length} as PaginationDTO, {traderIds})).items) {
        groups[group.id.toString()] = group
      }

      if (store.getters.isAdmin || store.getters.isOperator || store.getters.isTeamLead) {
        for (const trader of (await api.traders({offset:0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
          traders[trader.id.toString()] = trader
        }
      }

      for (const device of (await api.traderDevices({offset:0, limit: deviceIds.length} as PaginationDTO, {ids: deviceIds})).items) {
        devices[device.id.toString()] = device
      }

      for (const item of state.requisites.items) {
        item.trader = traders[item.traderId.toString()] ?? null;
        if (item.deviceId) {
          item.device = devices[item.deviceId.toString()] ?? null;
        }
        if (item.groupId) {
          item.group = groups[item.groupId!.toString()] ?? null;
        }
        if (item.isWhiteTriangle === undefined || item.isWhiteTriangle === null) {
          item.isWhiteTriangle = false;
        }
      }

      pageLoader.value?.hide()
    }

    const onRequisitesReorder = async (event: {oldIndex?: number, newIndex?: number}) => {
      if (event.oldIndex == null || event.newIndex == null || event.oldIndex === event.newIndex) {
        return;
      }

      const items = state.requisites.items.slice()
      const [moved] = items.splice(event.oldIndex, 1)
      if (!moved) {
        return;
      }
      items.splice(event.newIndex, 0, moved)
      state.requisites.items = items

      try {
        await api.reorderRequisites(items.map((item) => item.id))
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans('requisites.notice.reorder_error')});
        load()
      }
    }

    const onBlackListModalUpdated = (e: any) => {
      const item = state.requisites.items.filter(req => req.id === e.id)[0];
      if (item) {
        item.isActive = e.isActive
      }
    }

    const toggleRequisitesActivity = async ($event: any, item: TraderRequisitesDTO) => {
      if ($event.target.checked && (store.getters.isTrader || store.getters.isTraderOperator || store.getters.isTeamLead) && state.blacklistMethods.includes(item.method)) {
        item.isActive = false
        requisitesConfirmModal.value?.show(item);
        return;
      }

      pageLoader.value?.show();
      try {
        const req = await api.toggleRequisitesActivity(item.id, $event.target.checked ? 'enable' : 'disable')
        item.isActive = req.isActive
      } finally {
        pageLoader.value?.hide()
      }
    }

    const showDevicesModal = () => {
      state.devicesModal = true
      deviceList.value?.load();
    }

    const showGroupsModal = () => {
      state.groupsModal = true
      groupsList.value?.load();
    }

    const showHistoryModal = async (dto: TraderRequisitesDTO) => {
      state.currentRequisites = dto
      state.historyModal = true
      state.historyPage = 1
      loadRequisitesHistory(dto)
    }

    const showImportModal = async () => {
      helper.clearErrors('requisitesForm')
      createForm.value?.setForm({
        ...defaultCreateForm,
        mappingRowNum: 2,
        requisites: "import",
        isActive: true,
        isFarmsSettingsEnabled: true,
        concurrentTradesCount: 1,
        paymentOption: 'SBP_QR',
        currency: 'RUB',
        crossBorderCurrency: "TJS",
        method: 'multitransfer',
        minPayInDealSum: '1000',
        maxPayInDealSum: '50000',
        dayTradesCountLimit: 2,
        monthTradesSumLimit: '3000000',
        dayTradesSumLimit: '3000000',
        file: null,
      } as RequisitesFormDTO, state.blacklistMethods, true)
      state.createModalTitle = helper.trans('labels.import_requisites')
      state.createModal = true;
    }

    const showEditModal = async (dto: TraderRequisitesDTO|null = null) => {
      helper.clearErrors('requisitesForm')
      if (!dto) {
        createForm.value?.setForm({
          ...defaultCreateForm,
          raw: {},
          p2cConfig: {},
          maxReuseCountEnable: store.getters.getUser.isRequisitesReuseEnable,
          ...(store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled
            ? {reusablePaymentsCountLimit: store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11}
            : {}),
        } as RequisitesFormDTO, state.blacklistMethods)
        state.createModalTitle = helper.trans('labels.create_requisites')
      } else {
        state.createModalTitle = helper.trans('labels.edit_requisites', {req: dto.requisites || dto.holderName})
        createForm.value?.setForm({
          ...defaultCreateForm,
          ...dto,
          raw: dto.raw && typeof dto.raw === 'object' ? {...dto.raw} : {},
          isWhiteTriangle: dto.isWhiteTriangle ?? false,
          dayTradesSum: dto.dayTradesSum.amount,
          dayTradesSumLimit: Number.parseInt(dto.dayTradesSumLimit.amount).toString(),
          monthTradesSum: dto.monthTradesSum.amount,
          monthTradesSumLimit: Number.parseInt(dto.monthTradesSumLimit.amount).toString(),
          totalTradesCount: dto.totalTradesCount,
          totalTradesSum: dto.totalTradesSum.amount,
          totalTradesSumLimit: Number.parseInt(dto.totalTradesSumLimit.amount).toString(),
          manualResetEnabled: dto.manualResetEnabled ?? false,
          minPayInDealSum: dto.minPayInDealSum ? Number.parseInt(dto.minPayInDealSum!.amount).toString() : null,
          maxPayInDealSum: dto.maxPayInDealSum ? Number.parseInt(dto.maxPayInDealSum!.amount).toString() : null,
          multiplesOfValue: dto.multiplesOfValue != null ? String(dto.multiplesOfValue) : null,
          maxReuseCountEnable: store.getters.getUser.isRequisitesReuseEnable ?? true,
          ...(store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled
            ? {reusablePaymentsCountLimit: store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11}
            : {}),
          traderRequisitesLimit: dto.trader?.requisitesLimits?.[0] ?? null,
          deviceId: dto.device
        } as RequisitesFormDTO, state.blacklistMethods)
      }
      state.createModal = true;
    }

    const showEditPayInDealSumsModal = async (dto: TraderRequisitesDTO) => {
      payInDealSumsForm.value?.setForm({
        ...dto,
        minPayInDealSum: dto.minPayInDealSum ? Number.parseInt(dto.minPayInDealSum!.amount).toString() : null,
        maxPayInDealSum: dto.maxPayInDealSum ? Number.parseInt(dto.maxPayInDealSum!.amount).toString() : null,
        traderRequisitesLimit: dto.trader?.requisitesLimits?.[0] ?? null
      } as RequisitesPayInDealSumsFormDTO)

      state.payInDealSumsModal = true;
    }

    const confirmRequisitesDelete = async () => {
      if (!state.deleteRequisites) {
        return;
      }
      loaderDeleteRequisites.value?.show()
      await api.deleteRequisites(state.deleteRequisites.id)
      loaderDeleteRequisites.value?.hide()
      state.deleteRequisites = null
      load();
    }

    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        id: null,
        ids: [],
        currencies: [],
        statuses: [],
        traderIds: [],
        methods: [],
        query: '',
        isDeleted: 'false',
        options: [],
        groupId: null,
        deviceId: null,
        minAmount: null,
        maxAmount: null,
        storeId: null,
        counterpartyUserId: null,
      }
      state.tradersFilter = []
      load()
    }

    const onDeviceUpdated = async (deviceDTO: TraderDeviceDTO) => {

      for (const item of state.requisites.items) {
        if (!item.device) {
          continue
        }

        if (item.device.id !== deviceDTO.id) {
          continue
        }

        item.device = {...item.device, ...deviceDTO}
      }
    }

    const isMonthLimitReached = (item: TraderRequisitesDTO) =>  {
      return parseInt(item.monthTradesSum.amount) / parseInt(item.monthTradesSumLimit.amount) >= 0.9
    }

    const isDayLimitReached = (item: TraderRequisitesDTO) =>  {
      return parseInt(item.dayTradesSum.amount) / parseInt(item.dayTradesSumLimit.amount) >= 0.9
    }

    const savePayInDealSums = async () => {
      loaderPayInDealSums.value?.show()

      try {
        await payInDealSumsForm.value?.save()
        state.payInDealSumsModal = false;
        load();
      } finally {
        loaderPayInDealSums.value?.hide()
      }

    }

    const readMultiplesOfValue = (value: string | number | null | undefined): number | null => {
      const raw = `${value ?? ''}`.replace(/\s/g, '')
      if (!raw) {
        return null
      }
      const parsed = Number.parseInt(raw, 10)
      return parsed > 0 ? parsed : null
    }

    const makeImport = async () => {
      loaderCreateFrom.value?.show()

      const form = createForm.value!.getForm();

      try {
        const paymentSystems = store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption) as string[];
        const {multiplesOfValue, ...importFields} = form
        const data = {
          ...importFields,
          isWhiteTriangle: form.isWhiteTriangle ?? false,
          requisites: form.paymentOption === PaymentOption.MANUAL_SBP_QR ? '' : form.requisites,
          accountNumber: form.paymentOption === PaymentOption.TO_ACCOUNT ? form.requisites : form.accountNumber,
          paymentSystem: paymentSystems.includes(form.paymentSystem ?? '') ? form.paymentSystem : null,
          dayTradesCountLimit: form.dayTradesCountLimit ? Number.parseInt(form.dayTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
          monthTradesCountLimit: form.monthTradesCountLimit ? Number.parseInt(form.monthTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
          monthTradesSumLimit: form.monthTradesSumLimit ? Number.parseInt(form.monthTradesSumLimit!.replace(/\s/g, '')) : null,
          dayTradesSumLimit: form.dayTradesSumLimit ? Number.parseInt(form.dayTradesSumLimit!.replace(/\s/g, '')) : null,
          totalTradesCountLimit: form.totalTradesCountLimit ? Number.parseInt(form.totalTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
          totalTradesSumLimit: form.totalTradesSumLimit ? Number.parseInt(form.totalTradesSumLimit!.replace(/\s/g, '')) : null,
          minPayInDealSum: form.minPayInDealSum ? Number.parseInt(form.minPayInDealSum!.replace(/\s/g, '')) : null,
          maxPayInDealSum: form.maxPayInDealSum ? Number.parseInt(form.maxPayInDealSum!.replace(/\s/g, '')) : null,
          ...(store.getters.getAppData?.payInMultiplesEnabled ? {multiplesOfValue: readMultiplesOfValue(multiplesOfValue)} : {}),
          concurrentTradesCount: form.concurrentTradesCount ? Number.parseInt(form.concurrentTradesCount!.toString()!.replace(/\s/g, '')) : null,
          tradesTimeoutMinutes: form.tradesTimeoutMinutes ? Number.parseInt(form.tradesTimeoutMinutes!.toString()!.replace(/\s/g, '')) : null,
          reuseDaysCount: form.reuseDaysCount ? Number.parseInt(form.reuseDaysCount!.toString()!.replace(/\s/g, '')) : 0,
          traderId: form.trader?.id,
          file: form.file!.id,
          deviceId: (form.deviceId as unknown as TraderDeviceDTO)?.id
        } as BulkRequisitesUploadRequestDTO;

        await api.importRequisites(data);
        notification.notify({title: helper.trans('requisites.notice.imported')});
        state.createModal = false;
        load();
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans('requisites.notice.import_error')});
      } finally {
        loaderCreateFrom.value?.hide();
      }
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      const form = createForm.value!.getForm();
      const maxMaxReuseCount = store.getters.getAppData?.requisitesMaxReuseCount ?? 15;

      const paymentSystems = store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption) as string[];

      const maxReuseCount = form.maxReuseCount ? Number.parseInt(form.maxReuseCount!.toString()!.replace(/\s/g, '')) : null;
      if (maxReuseCount !== null && (maxReuseCount < 1 || maxReuseCount > maxMaxReuseCount)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "maxReuseCount",
          message: `${helper.trans('labels.maxReuseCount')}: ${helper.trans('server_errors.INVALID_VALUE')} (1-${maxMaxReuseCount})`,
        }]);
        loaderCreateFrom.value?.hide()
        return;
      }

      const holderName = form.holderName?.trim() ?? ''
      if (form.paymentOption === PaymentOption.VIET_QR && !holderName) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "holderName",
          message: helper.trans('labels.viet_qr_holder_name_required'),
        } as ValidationErrorDTO])
        loaderCreateFrom.value?.hide()
        return
      }

      if (form.paymentOption === PaymentOption.VIET_QR && !isVietQrRawComplete(form.raw as Record<string, unknown>)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "raw_field_qrString",
          message: helper.trans('labels.viet_qr_required'),
        } as ValidationErrorDTO])
        loaderCreateFrom.value?.hide()
        return
      }

      if (form.paymentOption === PaymentOption.IND_QR && !isQrisRawComplete(form.raw as Record<string, unknown>)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "raw_field_qrImage",
          message: helper.trans('labels.qris_required'),
        } as ValidationErrorDTO])
        loaderCreateFrom.value?.hide()
        return
      }

      if (form.paymentOption === PaymentOption.BR_QR && !isPixRawComplete(form.raw as Record<string, unknown>)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "raw_field_qrImage",
          message: helper.trans('labels.pix_required'),
        } as ValidationErrorDTO])
        loaderCreateFrom.value?.hide()
        return
      }

      const isIndQrForm = form.paymentOption === PaymentOption.IND_QR
      const isBrQrForm = form.paymentOption === PaymentOption.BR_QR
      const isCrossBorder = form.paymentOption === PaymentOption.CROSS_BORDER
      let rawPayload = form.paymentOption === PaymentOption.VIET_QR
        ? buildVietQrRawPayload(form.raw as Record<string, unknown>)
        : isIndQrForm
          ? buildQrisRawPayload(form.raw as Record<string, unknown>)
          : isBrQrForm
            ? buildPixRawPayload(form.raw as Record<string, unknown>)
            : form.raw
      let requisites = form.paymentOption === PaymentOption.MANUAL_SBP_QR || isIndQrForm || isBrQrForm ? '' : form.requisites
      if (isCrossBorder) {
        rawPayload = crossBorderRawPayload(form.raw)
        if (crossBorderSwift(form.raw)) {
          requisites = crossBorderAccountRequisites(requisites)
        }
      }

      const {vietQrIsStatic, qrisIsStatic, pixIsStatic, multiplesOfValue, ...formFields} = form

      const data = {
        ...formFields,
        raw: rawPayload,
        isWhiteTriangle: form.isWhiteTriangle ?? false,
        requisites,
        holderName: form.paymentOption === PaymentOption.VIET_QR ? holderName : form.holderName,
        accountNumber: form.paymentOption === PaymentOption.TO_ACCOUNT ? form.requisites : isIndQrForm || isBrQrForm ? null : form.accountNumber,
        ...(form.paymentOption === PaymentOption.VIET_QR ? { vietQrIsStatic: !!vietQrIsStatic } : {}),
        ...(isIndQrForm ? { qrisIsStatic: !!qrisIsStatic } : {}),
        ...(isBrQrForm ? { pixIsStatic: pixIsStatic === true } : {}),
        paymentSystem: paymentSystems.includes(form.paymentSystem ?? '') ? form.paymentSystem : null,
        dayTradesCountLimit: form.dayTradesCountLimit ? Number.parseInt(form.dayTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesCountLimit: form.monthTradesCountLimit ? Number.parseInt(form.monthTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        dayTradesAllCountLimit: form.dayTradesAllCountLimit ? Number.parseInt(form.dayTradesAllCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesAllCountLimit: form.monthTradesAllCountLimit ? Number.parseInt(form.monthTradesAllCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesSumLimit: form.monthTradesSumLimit ? Number.parseInt(form.monthTradesSumLimit!.replace(/\s/g, '')) : null,
        dayTradesSumLimit: form.dayTradesSumLimit ? Number.parseInt(form.dayTradesSumLimit!.replace(/\s/g, '')) : null,
        totalTradesCountLimit: form.totalTradesCountLimit ? Number.parseInt(form.totalTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        totalTradesSumLimit: form.totalTradesSumLimit ? Number.parseInt(form.totalTradesSumLimit!.replace(/\s/g, '')) : null,
        minPayInDealSum: form.minPayInDealSum ? Number.parseInt(form.minPayInDealSum!.replace(/\s/g, '')) : null,
        maxPayInDealSum: form.maxPayInDealSum ? Number.parseInt(form.maxPayInDealSum!.replace(/\s/g, '')) : null,
        ...(store.getters.getAppData?.payInMultiplesEnabled ? {multiplesOfValue: readMultiplesOfValue(multiplesOfValue)} : {}),
        concurrentTradesCount: form.concurrentTradesCount ? Number.parseInt(form.concurrentTradesCount!.toString()!.replace(/\s/g, '')) : null,
        maxReuseCount,
        reuseDaysCount: form.reuseDaysCount ? Number.parseInt(form.reuseDaysCount!.toString()!.replace(/\s/g, '')) : 0,
        ...(store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled
          ? {reusablePaymentsCountLimit: store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11}
          : {}),
      } as RequisitesUpdateRequestDTO;

      let promise;
      if (form.id) {
        promise = api.updateRequisites(form.id, data)
          .then((resp) => {
            notification.notify({title: helper.trans('requisites.notice.updated')});
            return resp;
          })
      } else {
        promise = api.createRequisites(data)
          .then((resp) => {
            notification.notify({title: helper.trans('requisites.notice.created')});
            return resp;
          })
      }

      promise
        .then((resp) => {
          // Обновляем реквизит в списке если он уже существует
          if (resp.id) {
            const existingIndex = state.requisites.items.findIndex(item => item.id === resp.id);
            if (existingIndex !== -1) {
              state.requisites.items[existingIndex] = resp;
            }
          }

          if (resp.fraudexCheck && store.getters.getAppData?.fraudexEnabled) {
            state.fraudexCheckData = resp;
            state.fraudexCheckModal = true;
          } else {
            state.createModal = false;
            if (!form.id) {
              load();
            }
          }
        })
        .catch((e: any) => {
          if (e.response && e.response.status === 400 && e.response.data) {
            const errorData = e.response.data;

            if (Array.isArray(errorData) && errorData.length > 0) {
              const manualEcomError = errorData.find(
                (err: any) =>
                  (err.message && err.message.includes('Trader can have only one MANUAL_ECOM requisite')) ||
                  err.field === 'paymentOption'
              );
              if (manualEcomError) {
                helper.setErrors('requisitesForm', [{
                  code: 'ONLY_ONE_REQUISITE_OF_THIS_TYPE',
                  field: 'paymentOption',
                  message: helper.trans('server_errors.ONLY_ONE_REQUISITE_OF_THIS_TYPE')
                }]);
                return;
              }
              const error = errorData[0];
              if (error.message && error.message.includes('Min pay-in deal sum cannot be greater than trader limit')) {
                const traderLimitError = {
                  code: 'MIN_PAY_IN_DEAL_SUM_EXCEEDS_TRADER_LIMIT',
                  field: 'minPayInDealSum',
                  message: error.message
                };
                helper.setErrors('requisitesForm', [traderLimitError]);
                return;
              }
              const qrisLabel = qrisBackendErrorLabel(error.message)
              if (qrisLabel) {
                helper.setErrors('requisitesForm', [{
                  code: 'INVALID_VALUE',
                  field: 'raw_field_qrImage',
                  message: helper.trans(qrisLabel),
                } as ValidationErrorDTO]);
                return;
              }
              const pixLabel = pixBackendErrorLabel(error.message)
              if (pixLabel) {
                helper.setErrors('requisitesForm', [{
                  code: 'INVALID_VALUE',
                  field: 'raw_field_qrImage',
                  message: helper.trans(pixLabel),
                } as ValidationErrorDTO]);
                return;
              }
            }
          }

          helper.handleErrors('requisitesForm', e)
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })

    }

    const resetTotalLimit = async () => {
      const form = createForm.value!.getForm();
      if (!form.id) {
        return;
      }

      loaderCreateFrom.value?.show()
      try {
        const updated = await api.resetRequisitesLimits(form.id, 'total');

        createForm.value?.setForm({
          ...form,
          totalTradesCount: updated.totalTradesCount,
          totalTradesSum: updated.totalTradesSum.amount,
        } as RequisitesFormDTO, state.blacklistMethods)

        notification.notify({title: helper.trans('requisites.notice.updated')});

        const existingIndex = state.requisites.items.findIndex(item => item.id === updated.id);
        if (existingIndex !== -1) {
          state.requisites.items[existingIndex] = updated;
        }
      } catch (e: any) {
        helper.handleErrors('requisitesForm', e)
      } finally {
        loaderCreateFrom.value?.hide();
      }
    }

    const loadRequisitesHistory = async (dto: TraderRequisitesDTO) => {

      state.requisitesHistoryResponse.offset = state.requisitesHistoryResponse.limit * (state.historyPage - 1)
      try {
        state.requisitesHistoryResponse = await api.requisitesActionHistory(dto.id, state.requisitesHistoryResponse)

        if (!(store.getters.isTrader || store.getters.isTraderOperator)) {
          let usersIds = [] as string[];
          for (const item of state.requisitesHistoryResponse.items) {
            if (item.initiatorId && !usersIds.includes(item.initiatorId)) {
              usersIds.push(item.initiatorId)
            }
          }

          if (usersIds.length > 0) {
            const users = (await api.users({limit: usersIds.length, offset:0 } as PaginationDTO, {ids: usersIds})).items;
            let userByIds = {} as Dictionary<UserDTO>
            for (const user of users) {
              userByIds[user.id] = user
            }

            for (const item of state.requisitesHistoryResponse.items) {
              if (item.initiatorId) {
                item.initiator = userByIds[parseInt(item.initiatorId)] ?? null
              }
            }
          }
        }
      } catch (error) {
        // Handle error silently
      } finally {
      }
    }

    onMounted(async () => {
      store.dispatch("trafficGroups/loadList");
      state.blacklistMethods = (await api.paymentMethodBlackList());
      load();
    });



    const groupedHistory = computed(() => {
      const grouped: { [key: string]: any } = {};
      state.requisitesHistoryResponse.items.forEach(history => {
        if (!grouped[history.changeGroupId]) {
          grouped[history.changeGroupId] = {
            changeGroupId: history.changeGroupId,
            date: history.date,
            changes: [],
            initiatorType: history.initiatorType,
            initiatorRole: history.initiatorRole,
            initiator: history.initiator
          };
        }
        grouped[history.changeGroupId].changes.push({
          id: history.id,
          fieldName: history.fieldName,
          oldValue: history.oldValue,
          newValue: history.newValue
        });
      });
      return Object.values(grouped).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    });

    const getActionDescription = (changes: any[]) => {
      if (changes.length === 0) return '';

      const hasActiveChange = changes.some(c => c.fieldName === 'isActive');
      const hasDeletedChange = changes.some(c => c.fieldName === 'deletedAt');
      const hasLimitChanges = changes.some(c =>
        c.fieldName.includes('Limit') ||
        c.fieldName.includes('Sum') ||
        c.fieldName === 'concurrentTradesCount' ||
        c.fieldName === 'tradesTimeoutMinutes'
      );

      if (hasDeletedChange) return 'Удаление';
      if (hasActiveChange) {
        const activeChange = changes.find(c => c.fieldName === 'isActive');
        return activeChange?.newValue === 'true' ? 'Включение' : 'Отключение';
      }
      if (hasLimitChanges) return 'Обновление лимитов';

      if (changes.length > 5) return 'Создание';

      return 'Обновление';
    };

    const getFieldName = (fieldName: string) => {
      const fieldNames: { [key: string]: string } = {
        currency: 'валюта',
        crossBorderCurrency: 'кросс-валюта',
        isActive: 'активность',
        requisites: 'реквизиты',
        holderName: 'владелец',
        accountNumber: 'номер счета',
        method: 'метод',
        paymentOption: 'опция платежа',
        paymentSystem: 'платежная система',
        dayTradesCountLimit: 'дневной лимит сделок',
        monthTradesCountLimit: 'месячный лимит сделок',
        dayTradesSumLimit: 'дневной лимит суммы',
        monthTradesSumLimit: 'месячный лимит суммы',
        deviceId: 'устройство',
        groupId: 'группа',
        concurrentTradesCount: 'количество одновременных сделок',
        tradesTimeoutMinutes: 'таймаут сделок',
        isFarmsSettingsEnabled: 'настройки ферм',
        maxReuseCount: 'максимальное количество использований',
        reuseDaysCount: 'период использования, дней',
        reusablePaymentsCountLimit: 'лимит платежей на контрагента',
        dayTradesAllCountLimit: 'дневной лимит всех сделок',
        monthTradesAllCountLimit: 'месячный лимит всех сделок',
        totalTradesCountLimit: 'общий лимит сделок',
        totalTradesSumLimit: 'общий лимит суммы',
        manualResetEnabled: 'ручной сброс общих лимитов',
        onlyInternalTransfer: 'только внутренние переводы',
        isWhiteTriangle: 'белый треугольник',
        minPayInDealSum: 'минимальная сумма сделки',
        maxPayInDealSum: 'максимальная сумма сделки',
        multiplesOfValue: 'кратность заявки',
        isAgreeBlacklistPaymentMethod: 'согласие на рискованные методы'
      };
      return fieldNames[fieldName] || fieldName;
    };

    const formatValue = (value: any, fieldName?: string) => {
      if (value === null || value === undefined || value === 'null') return '-';
      if (value === 'deleted') return 'удален';
      if (value === 'true') return 'да';
      if (value === 'false') return 'нет';

      if (fieldName === 'method') {
        return helper.trans(`pay_methods.${value.toLowerCase()}`) || value;
      }

      if (fieldName === 'paymentOption') {
        return helper.trans(`payment_options.${value}`) || value;
      }

      if (fieldName === 'paymentSystem') {
        return helper.trans(`payment_systems.${value}`) || value;
      }

      return value;
    };

    const showCounterpartiesModal = (requisitesId: number) => {
      counterpartiesModal.value?.show(requisitesId)
    }

    const onCounterpartiesImported = (requisitesId: number) => {
      if (counterpartiesModal.value?.isVisible && counterpartiesModal.value?.requisitesId === requisitesId) {
        counterpartiesModal.value.load()
      }
    }

    const handleFraudexCheckContinue = () => {
      state.fraudexCheckModal = false;
      if (state.fraudexCheckData?.id) {
        const existingIndex = state.requisites.items.findIndex(item => item.id === state.fraudexCheckData!.id);
        if (existingIndex !== -1) {
          state.requisites.items[existingIndex] = state.fraudexCheckData;
        }
      }
      state.fraudexCheckData = null;
      state.createModal = false;
      load();
    }

    const handleFraudexCheckCancel = () => {
      state.fraudexCheckModal = false;
      state.fraudexCheckData = null;
    }

    const showFraudexFeedbackModal = (requisite: TraderRequisitesDTO) => {
      state.fraudexFeedbackRequisite = requisite;
      state.fraudexFeedbackModal = true;
    }

    const handleFraudexFeedbackSubmit = async (text: string) => {
      if (!store.getters.getAppData?.fraudexEnabled) {
        return;
      }

      if (!state.fraudexFeedbackRequisite) {
        return;
      }

      try {
        await api.sendFraudexFeedback(state.fraudexFeedbackRequisite.id, text);
        notification.notify({
          title: helper.trans('fraudex.feedback_sent'),
          type: 'success'
        });
        state.fraudexFeedbackModal = false;
        state.fraudexFeedbackRequisite = null;
      } catch (e) {
        helper.handleErrors('fraudexFeedback', e);
      }
    }

    return {
      ...toRefs(state),
      pageLoader,
      dateHelper,
      helper,
      numberFormatter,
      hasFrozenSums,
      sumTitle,
      createForm,
      deviceList,
      load,
      onRequisitesReorder,
      reorderEnabled,
      storeCounterpartyAllowlistEnabled,
      showImportModal,
      showEditModal,
      showDevicesModal,
      showGroupsModal,
      toggleRequisitesActivity,
      applyFilters,
      clearFilters,
      loaderCreateFrom,
      loaderDeleteRequisites,
      makeImport,
      save,
      resetTotalLimit,
      confirmRequisitesDelete,
      groupsList,
      store,
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      isTrader: computed(() => store.getters.isTrader),
      isTraderOperator: computed(() => store.getters.isTraderOperator),
      isTeamLead: computed(() => store.getters.isTeamLead),
      currencyList: computed(() => store.getters["currencyMethods/currencies"]),
      methodList: computed(() => store.getters["currencyMethods/methods"]),
      isMonthLimitReached,
      isDayLimitReached,
      onDeviceUpdated,
      payInDealSumsForm,
      showEditPayInDealSumsModal,
      savePayInDealSums,
      loaderPayInDealSums,
      requisitesConfirmModal,
      onBlackListModalUpdated,
      PaymentOption,
      hasRole: computed(() => store.getters.hasRole),
      UserRole,
      loadRequisitesHistory,
      historyPage: toRef(state, 'historyPage'),
      requisitesHistoryResponse: computed(() => state.requisitesHistoryResponse),
      showHistoryModal,
      groupedHistory,
      getActionDescription,
      getFieldName,
      formatValue,
      showCounterpartiesModal,
      onCounterpartiesImported,
      counterpartiesModal,
      counterpartiesImportModal,
      handleFraudexCheckContinue,
      handleFraudexCheckCancel,
      showFraudexFeedbackModal,
      handleFraudexFeedbackSubmit,
      vietQrEmvFromRaw,
      qrisEmvFromRaw,
      pixEmvFromRaw,
      truncateVietQrEmvDisplay,
      crossBorderSwift
    }
  },
  async beforeMount() {
    const store = useStore();
    try {
      await store.dispatch("reqGroups/loadList");
    } catch (e) {
    }

  }
})
</script>
